export default "__VITE_ASSET__DDYLTW9w__"